/**
 * Constants for AI Insights feature
 */

export const INSIGHT_TYPES = {
  SUMMARY: 'SUMMARY',
  SENTIMENT: 'SENTIMENT',
  TOPICS: 'TOPICS',
  RECOMMENDATIONS: 'RECOMMENDATIONS'
};

export const VIEW_MODES = {
  COMPACT: 'COMPACT',
  DETAILED: 'DETAILED',
  RAW: 'RAW'
};

export const ERROR_MESSAGES = {
  NO_EVENT_ID: 'No event ID provided',
  FETCH_FAILED: 'Failed to fetch insights',
  INVALID_MODEL: 'Invalid model selected',
  NETWORK_ERROR: 'Network error occurred'
};

/**
 * Required sections for each question type
 */
export const REQUIRED_SECTIONS = {
  DEFAULT: ['executiveSummary', 'keyThemes', 'actionableInsights', 'nextSteps'],
  OPEN_ENDED: ['executiveSummary', 'keyThemes', 'actionableInsights', 'nextSteps'],
  BINARY: ['executiveSummary', 'responseDistribution', 'keyInsights', 'recommendations'],
  MULTIPLE_CHOICE: ['executiveSummary', 'optionDistribution', 'patternAnalysis', 'recommendations'],
  MULTIPLE_RATING: ['executiveSummary', 'ratingAnalysis', 'distributionAnalysis', 'recommendations'],
  SCALE: ['executiveSummary', 'scoreAnalysis', 'keyInsights', 'recommendations'],
  SCALE_5: ['executiveSummary', 'scoreAnalysis', 'keyInsights', 'recommendations'],
  SCALE_10: ['executiveSummary', 'scoreAnalysis', 'keyInsights', 'recommendations'],
  STACK_RANK: ['executiveSummary', 'priorityDistribution', 'keyInsights', 'recommendations'],
  MATRIX: ['executiveSummary', 'matrixAnalysis', 'keyInsights', 'recommendations'],
  RATING: ['executiveSummary', 'ratingDistribution', 'keyInsights', 'recommendations'],
  RANKING: ['executiveSummary', 'rankingAnalysis', 'keyInsights', 'recommendations']
};

// Processing stage identifiers used across Saga, Reducer and UI
export const PROCESSING_STAGES = {
  LOADING_CACHED: 'loading_cached',
  PROMPT_GENERATION: 'prompt_generation',
  API_REQUEST: 'api_request',
  PARSING_RESPONSE: 'parsing_response'
};
